import {
  Component,
  OnInit,
  ChangeDetectorRef,
  inject,
  EnvironmentInjector,
  runInInjectionContext,
} from "@angular/core";
import { Database, ref, get } from "@angular/fire/database";
import { ProfileService } from "../../providers/profile.service";
import { BvDialogService } from "../../design-system";
import { LoadingOverlayComponent } from "../../shared/loading-overlay/loading-overlay.component";
import { BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";

import { FormsModule } from "@angular/forms";
import { BvFormFieldComponent } from "../../design-system/primitives/form-field.component";
import { BvInputDirective } from "../../design-system/primitives/input.directive";
import { CloseDialogButtonComponent } from "../../shared/close-dialog-button/close-dialog-button.component";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-join-club",
    templateUrl: "./join-club.component.html",
    styleUrls: ["./join-club.component.scss"],
    imports: [LoadingOverlayComponent, BvDialogTitleComponent, BvDialogBodyComponent, FormsModule, BvFormFieldComponent, BvInputDirective, BvDialogFooterComponent, CloseDialogButtonComponent, BvButtonComponent, TranslateModule]
})
export class JoinClubComponent implements OnInit {
  foundClub: any;
  clubID!: string;
  joinCLub: boolean = false;
  private readonly mdb = inject(Database);
  private readonly injector = inject(EnvironmentInjector);
  constructor(private profServ: ProfileService, private dialog: BvDialogService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {}
  sendJoinRequest() {
    this.joinCLub = true;
    this.profServ.createJoinRequest(this.foundClub).then(() => {
      this.joinCLub = false;
      this.cdr.markForCheck();
    });
    this.dialog.closeAll();
  }
  clubIDChange(evt: string) {
    if (evt.length == 4)
      runInInjectionContext(this.injector, () =>
        get(ref(this.mdb, "public/" + evt.toUpperCase()))
      ).then((snapshot) => {
        let club: any = snapshot.val();
        if (club && club.clubID) {
          if (
            this.profServ.latestProfile &&
            this.profServ.latestProfile.clubs &&
            this.profServ.latestProfile.clubs[club.clubID]
          )
            alert("You are already a member of this club");
          else {
            this.foundClub = club;
          }
        } else alert("Club not found");
        // Raw Firebase .once() callback — notify CD under zoneless.
        this.cdr.markForCheck();
      });
    else this.foundClub = null;
  }
}
